import styled from '@emotion/styled'
import ProductLocations from 'legacy/routes/catalog/products/product/edit/ProductLocations'

export const ProductsViewStoreLocations = styled(ProductLocations)({
  display: 'flex',
  flexDirection: 'column',

  '.rt-table': {
    height: '0 !important', // yay css bugs! passing 100% or auto won't do here.
  },

  '.ReactTable': {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
})
